import React, { useContext } from 'react'
import styled from 'styled-components'

import Pill from 'components/Luxkit/Pill'
import config from 'constants/config'
import FormatCurrency from 'components/Common/FormatCurrency'
import TaxesAndFees from 'components/OfferPage/PackageOption/Pricing/TaxesAndFees'
import GeoContext from 'contexts/geoContext'
import BodyText from 'components/Luxkit/Typography/BodyText'
import PaletteProvider from 'contexts/PaletteProvider'
import Group from 'components/utils/Group'
import { pluralizeToString } from 'lib/string/pluralize'
import PriceRowPrice from 'components/Luxkit/PricePoints/PriceRowPrice'
import PriceRowPriceCaption from 'components/Luxkit/PricePoints/PriceRowPriceCaption'

const Root = styled.div`
`

interface Props {
  rate?: App.BedbankRate;
  offer: App.BedbankOffer | App.BedbankOfferSummary;
}

function HeroBedbankPriceDetails(props: Props) {
  const {
    rate,
    offer,
  } = props

  const { showTaxExclusivePrices } = useContext(GeoContext)

  const taxesAndFees = rate?.totals?.taxesAndFees ?? 0
  const propertyFees = rate?.totals?.propertyFees ?? 0
  const hotelPrice = rate ? (showTaxExclusivePrices ? rate.totals.exclusive : rate.totals.inclusive) : offer.sell?.price
  const hotelValue = rate?.value ?? offer.sell?.value
  const hotelDiscount = rate?.discount ?? offer.sell?.discount ?? 0

  const hotelNights = rate?.nights ?? offer?.sell?.los

  if (!hotelPrice) {
    return null
  }
  const totalPrice = showTaxExclusivePrices ? hotelPrice : hotelPrice + propertyFees

  return <Root>
    <PriceRowPriceCaption>
      {pluralizeToString('night', hotelNights!)} from
    </PriceRowPriceCaption>
    <PriceRowPrice size="L" price={totalPrice} saleUnit="total" taxesAndFees={taxesAndFees} />

    {taxesAndFees > 0 && (<TaxesAndFees taxAmount={taxesAndFees} />)}
    {hotelDiscount > 0 &&
      <BodyText variant="small" weight="semi-bold" colour="neutral-one">
        <Group direction="horizontal" gap={8} verticalAlign="center">
          Valued up to <FormatCurrency value={hotelValue || hotelPrice} format="roundedDollar" />
          {hotelDiscount > config.displayDiscountThreshold.bedbank &&
            <PaletteProvider type="default">
              <Pill kind="primary" variant="success">
                -{Math.floor(hotelDiscount * 100)}%
              </Pill>
            </PaletteProvider>
          }
        </Group>
      </BodyText>
    }
  </Root>
}

export default HeroBedbankPriceDetails
